<template>
  <v-app>
    <!-- Drawer -->
    <v-navigation-drawer v-model="viewModel.drawer.value" app>
      <!-- Profile Section -->
      <div class="text-center py-4">
        <v-avatar
          size="50"
          color="primary"
          variant="tonal"
          class="mx-auto font-weight-bold"
        >
          {{ viewModel.userInitial }}
        </v-avatar>
        <div class="mt-2">
          <strong class="text-subtitle-2 font-weight-bold text-capitalize">{{
            viewModel.hideWords(viewModel.userName.value)
          }}</strong>
          <br />
          <small class="text-caption text-capitalize">{{
            viewModel.hideEmailCharacters(viewModel.userEmail.value)
          }}</small>
        </div>
      </div>
      <v-divider></v-divider>

      <!-- Navigation Options -->
      <v-list>
        <v-list-item
          v-for="option in viewModel.options"
          :key="option.title"
          @click="viewModel.navigateTo(option.route)"
          :active="viewModel.isActiveRoute(option.route)"
        >
          <v-icon size="20" start>{{ option.icon }}</v-icon>
          <span class="text-subtitle-2">{{ option.title }}</span>
        </v-list-item>

        <!-- Logout Option -->
        <v-divider></v-divider>
        <v-col
          align="center"
          justify="center"
          class="d-flex flex-column mt-2"
          style="height: 100%"
        >
          <v-btn
            variant="tonal"
            @click="viewModel.logout()"
            class="text-primary"
          >
            <v-icon start>mdi-logout</v-icon>
            <span class="text-subtilte-2 text-capitalize">Salir</span>
          </v-btn>
        </v-col>
      </v-list>
    </v-navigation-drawer>

    <!-- Topbar -->
    <v-app-bar app elevation="1">
      <v-app-bar-nav-icon
        v-if="viewModel.isLargeScreen"
        @click="viewModel.toggleDrawer()"
      />
      <v-toolbar-title
        class="text-subtitle-1 font-weight-bold text-capitalize"
        >{{ viewModel.appName }}</v-toolbar-title
      >
      <v-menu offset-y>
        <template v-slot:activator="{ props }">
          <v-btn variant="text" icon v-bind="props">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <!-- Profile Information -->
          <div class="text-center pa-4">
            <v-avatar
              size="30"
              variant="tonal"
              color="primary"
              class="mx-auto font-weight-bold"
            >
              {{ viewModel.userInitial }}
            </v-avatar>
            <div class="mt-2">
              <strong class="text-caption font-weight-bold text-capitalize">{{
                viewModel.hideWords(viewModel.userName.value)
              }}</strong>
              <br />
              <small class="text-caption text-capitalize">{{
                viewModel.hideEmailCharacters(viewModel.userEmail.value)
              }}</small>
            </div>
          </div>
          <v-divider></v-divider>
          <v-list width="250">
            <v-list-item>
              <template #default>
                <span class="text-caption">Modo Oscuro</span>
              </template>
              <template #append>
                <v-switch
                  v-model="viewModel.isDarkMode.value"
                  class="ml-auto"
                  hide-details
                  density="compact"
                  flat
                  color="primary"
                />
              </template>
            </v-list-item>
          </v-list>
          <!-- Logout Option -->
          <v-divider></v-divider>
          <v-col
            align="center"
            justify="center"
            class="d-flex flex-column"
            style="height: 100%"
          >
            <v-btn
              variant="tonal"
              @click="viewModel.logout()"
              class="text-primary"
            >
              <v-icon start>mdi-logout</v-icon>
              <span class="text-subtilte-2 text-capitalize">Salir</span>
            </v-btn>
          </v-col>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- Main Content -->
    <v-main>
      <v-container
        class="overflow-auto"
        fluid
        :class="viewModel.isDarkMode.value ? '' : 'bg-grey-lighten-4'"
        style="max-height: calc(100vh - 64px)"
      >
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import AppLayoutViewModel from "@/viewmodels/layouts/AppLayoutViewModel";
const viewModel = new AppLayoutViewModel();
</script>
